// Social profile links are typed by hand, often as "linkedin.com/in/name",
// "@name", just "name", or with a broken protocol like "https//...". Without a
// valid protocol the browser treats them as a page on our own site, so every
// link is turned into a full https:// URL here.
const PROFILE_BASE = {
  twitter: 'https://x.com/',
  instagram: 'https://www.instagram.com/',
  tiktok: 'https://www.tiktok.com/@',
  facebook: 'https://www.facebook.com/',
  linkedin: 'https://www.linkedin.com/in/',
};

// LinkedIn paths that are not a personal profile and must be left as they are
const LINKEDIN_SECTIONS = ['in', 'company', 'school', 'showcase', 'pub', 'posts', 'feed', 'groups', 'pulse', 'profile'];

export function normalizeSocialUrl(value, platform) {
  let url = String(value || '').trim();
  if (!url) return '';

  // When a link was pasted into a field that already held one, or saved with a
  // broken protocol and then prefixed, keep only the last real link in it.
  const lastLink = url.search(/(https?[:;]?\/*|www\.)(?!.*(https?[:;]?\/\/?|www\.))/i);
  if (lastLink > 0) url = url.slice(lastLink);

  // Repair "https//", "https:/", "http;//" and similar
  url = url.replace(/^(https?)[:;]*\/*/i, (m, scheme) => scheme.toLowerCase() + '://');
  if (url.startsWith('//')) url = 'https:' + url;

  if (!/^https?:\/\//i.test(url)) {
    if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+(\/|$)/i.test(url)) {
      // A domain or path someone pasted without the protocol
      url = 'https://' + url;
    } else {
      // Just a handle
      const handle = url.replace(/^@/, '').replace(/^\/+/, '');
      const base = PROFILE_BASE[platform];
      return base ? base + handle : '';
    }
  }

  // "linkedin.com/name" is not a profile; LinkedIn needs "/in/name"
  if (platform === 'linkedin') {
    const m = url.match(/^https?:\/\/([a-z]{2,3}\.)?(www\.)?linkedin\.com\/([^/?#]+)(.*)$/i);
    if (m && !LINKEDIN_SECTIONS.includes(m[3].toLowerCase())) {
      url = `https://www.linkedin.com/in/${m[3]}${m[4] || '/'}`;
    }
  }

  return url;
}
